import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {Store} from '@ngxs/store';
import {AuthActions} from '../state/auth/auth.actions';
import {catchError, map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthService,
                private store: Store) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authService.getCurrentUser().pipe(
            map((response) => {
                if (response.username) {
                    this.store.dispatch(new AuthActions.AuthSuccess(response));
                    return true;
                }
                this.store.dispatch(new AuthActions.AuthFailure());
                return false;
            }),
            catchError(() => {
                this.store.dispatch(new AuthActions.AuthFailure());
                return of(false);
            }));
    }
}
